
<template>
  <div>
    <v-card flat color="white lighten-1" class="rounded-lg mb-2 pa-3">
      <v-card-text>
        <v-form ref="form">
          <div class="d-flex flex-column">
            <!-- <SelectDepot v-on="$listeners"></SelectDepot> -->
            <SelectModality :object_with_model="client"/>
            <ClientInfoForm ref="info_form" creating  :client="client"></ClientInfoForm>
            <ChooseClientPortfolioForm ref="portfolio_form" :model="client"></ChooseClientPortfolioForm>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <f-btn save @click="emitSaveClient(true)">
        </f-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import validations from "@/mixins/validations.js"

export default {
  name: 'ClientInfoStepper',
  mixins:[ validations ],
  components: {
    SelectModality: () => import('@/components/shared/SelectModality.vue'),
    ClientInfoForm: () => import("@/_backoffice/_registrations/components/client/register/forms/ClientInfoForm.vue"),
    ChooseClientPortfolioForm: () => import("@/_backoffice/_registrations/components/shared/client_portfolio/ChooseClientPortfolioForm.vue")
  },
  props:{
    client:{
      type: Object,
      default: () => { return {} }
    }
  },
  methods: {
    validate(){
      return this.$refs.form.validate() && this.$refs.info_form.validate() && this.$refs.portfolio_form.validate()
    },
    emitSaveClient(increment){
      this.$emit("saveClient", increment)
    },
  },

}
</script>